export enum CardViewMode {
    DASHBOARD,
    PANEL,
    CONFIGURATION,
    EDIT,
}
